import { LinkLists, LinkListsProps } from 'designsystem/components/3-organisms/LinkLists';
import { LinkFeature } from 'features/Modules/Link';
import Link from 'next/link';

export const FooterLinksFeature: React.FC<Content.FooterLinks> = ({ content }) => {
	const { items } = content?.properties?.lists ?? {};
	const linkLists: LinkListsProps['lists'] = items.map((linkLists) => {
		return linkLists.content.properties.linkList?.items.map((list) => {
			return {
				heading: list.content.properties.heading,
				links: list.content.properties.links?.items?.map((linkData, index) => {
					const { link, language } = linkData?.content?.properties ?? {};
					const singleLink = link?.[0];
					if (!language) {
						return <LinkFeature style="arrow" key={index} {...singleLink} />;
					} else {
						let singleLinkUrl = singleLink?.url;
						if (singleLinkUrl === null) {
							singleLinkUrl = singleLink.route.path;
						}
						// This is necessary as long as we have third party scripts that
						// can only detect language updates through browser reloads
						return (
							<Link
								href={singleLinkUrl + (singleLink.queryString !== null ? singleLink.queryString : '')}
								target={singleLink?.target}
								key={index}
								locale={false}
							>
								{singleLink?.title}
							</Link>
						);
					}
				}),
			};
		});
	});

	return linkLists && <LinkLists lists={linkLists} />;
};
